import OverlayTips from "./OverlayTips";

export default {
    /**
     * Collect indexes of matched elements
     * @param $el
     * @param testF
     * @returns {*} jquery object with matched elements and tipData property
     */
    indexFilter: function($el, testF)
    {
        var tipData = {
            length: $el.length,
            indexes: []
        };

        var $ret = $el.filter(function(index)
                              {
                                  if (testF(this))
                                  {
                                      tipData.indexes.push(index);
                                      return true;
                                  }
                                  return false;
                              });
        $ret.tipData = tipData;
        return $ret;
    },

    /**
     * Find tips positions in table
     * @param tips - array of objects which provides:
     * gapLength - length in cells
     * setVal($el) - store result,
     * test(el) - boolean function to check if cell suitable
     * @param rowSource
     */
    setTipsForTable: function(tips, rowSource)
    {
        _.each(tips, function(tip) {tip.setVal($())});
        for (var idx = 0; tips.length > 0 && idx < rowSource.length; idx++)
        {
            var $row = rowSource.getRow(idx);

            for (var tipIdx = 0; tipIdx < tips.length; tipIdx++)
            {
                var tip = tips[tipIdx];
                var $matched = this.indexFilter($row, tip.test);
                if ($matched.length > 0)
                {
                    var resultIdx = $matched.tipData.indexes[$matched.length >> 1];

                    var leftLen = this._testLeftGap(tip, $row, resultIdx);
                    var rightLen = this._testRightGap(tip, $row, resultIdx);
                    var direction;

                    if (leftLen === -1)
                    {
                        if (rightLen === -1)
                            continue;

                        direction = OverlayTips.DIRECTION_TOP_RIGHT;
                        resultIdx += rightLen;
                    }
                    else if (rightLen === -1)
                    {
                        direction = OverlayTips.DIRECTION_TOP_LEFT;
                        resultIdx -= leftLen;
                    }
                    else if (leftLen === 0 && rightLen === 0)
                    {
                        direction = resultIdx < ($row.length >> 1) ? OverlayTips.DIRECTION_TOP_RIGHT : OverlayTips.DIRECTION_TOP_LEFT;
                    }
                    else if (leftLen < rightLen)
                    {
                        direction = OverlayTips.DIRECTION_TOP_LEFT;
                        resultIdx -= leftLen;
                    }
                    else
                    {
                        direction = OverlayTips.DIRECTION_TOP_RIGHT;
                        resultIdx += rightLen;
                    }

                    var $result = $($row[resultIdx]);
                    $result.config = {direction: direction};
                    tip.setVal($result);
                    tips.splice(tipIdx, 1);

                    // skip next row
                    idx++;
                    break;
                }
            }
        }
    },

    _testLeftGap: function(tip, $row, resultIdx)
    {
        var ret = -1;
        for (var i = resultIdx; i >= tip.gapLength && tip.test($row[i]); i--, ret++) {}
        return ret;
    },

    _testRightGap: function(tip, $row, resultIdx)
    {
        var ret = -1;
        for (var i = resultIdx; i < $row.length - tip.gapLength && tip.test($row[i]); i++, ret++){}
        return ret;
    },

    setLeaveChartTableTips: function(manager, $table)
    {
        var afterFirstRow = false;
        // find places for tips in Schedule of Colleagues
        var $recordsAfterFirst = $table
                .find('tr').filter(function()
                                   {
                                       if (afterFirstRow)
                                           return true;
                                       else if (this.className.indexOf('firstRow') > -1)
                                           afterFirstRow = true;
                                       return false;
                                   });

        // no splitting to words, need to be used carefully
        function testClass(el, className)
        {
            return el.className.indexOf(className) > -1;
        }

        var tips = [
            {
                gapLength: 17,
                setVal: function($el)
                {
                    manager.$tipNotApproved = $el;
                },
                test: function(el)
                {
                    return testClass(el, 'leaveType') && !testClass(el, 'approved');
                }
            },
            {
                gapLength: 12,
                setVal: function($el)
                {
                    manager.$tipApproved = $el;
                },
                test: function(el)
                {
                    return testClass(el, 'approved');
                }
            },
            {
                gapLength: 12,
                setVal: function($el)
                {
                    manager.$tipLeaveStatus = $el;
                },
                test: function(el)
                {
                    return testClass(el, 'leaveStatus');
                }
            }];

        var rowSource = {
            length: $recordsAfterFirst.length,
            getRow: function(idx)
            {
                return $($recordsAfterFirst[idx]).find('.dayCell');
            }
        };

        this.setTipsForTable(tips, rowSource);
    }
}


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/ApTipsUtils.js